import Image from 'next/image'
import Section from 'components/common/Section'
import { Marketing } from 'designsystem/Text'
import { ComponentHeadlineWithEmbed } from 'types/generated/contentful'

export const HeadlineWithEmbed = ({
  headline,
  subheadline,
  underHeadlineText,
  iframeUrl,
  iframeHeight,
  fullWidthImage,
}: ComponentHeadlineWithEmbed & { blockId: string }): JSX.Element => {
  return (
    <Section verticalPadding='xxs' bgColor='gray'>
      <div>
        <Marketing.H1 className='max-w-3xl text-center mx-auto'>
          {headline}
        </Marketing.H1>

        {subheadline && (
          <Marketing.SubHeadline className='spacer-3xs max-w-3xl lg:!text-[32px]'>
            {subheadline}
          </Marketing.SubHeadline>
        )}

        {underHeadlineText ? (
          <div className='flex spacer-3xs flex-col mx-auto justify-center max-w-3xl '>
            {underHeadlineText.split('\n').map((text, index) => (
              <p
                key={index}
                className='text-left spacer-3xs max-w-3xl lg:!text-[20px]'
              >
                {text}
              </p>
            ))}
          </div>
        ) : null}

        {fullWidthImage && (
          <div className='-mx-4 mt-16 lg:mt-36'>
            <Image
              src={fullWidthImage.url!}
              alt={fullWidthImage.title!}
              width={fullWidthImage.width!}
              height={fullWidthImage.height!}
            />
          </div>
        )}

        {iframeUrl && (
          <iframe
            src={iframeUrl}
            style={{
              width: '100%',
              height: iframeHeight ?? undefined,
            }}
          />
        )}
      </div>
    </Section>
  )
}
